// ─── Hash Router ────────────────────────────────────────────
// Routes simples basées sur le hash : `#/clients/123`, `#/devices/456`, etc.
// Une query string optionnelle porte les filtres de page :
// `#/alerts?severity=2&category=12`. Elle vit dans l'URL pour que F5, un
// signet ou un lien partagé retrouvent la même vue — sans elle, rafraîchir la
// page Alertes après avoir posé cinq filtres les perdait tous.

export function parseHash() {
  const raw = window.location.hash.replace(/^#\/?/, '') || 'dashboard';
  // La query est découpée AVANT le split sur « / », sinon une valeur de filtre
  // contenant une barre oblique casserait le nom de la vue.
  const qIndex = raw.indexOf('?');
  const path = qIndex === -1 ? raw : raw.slice(0, qIndex);
  const query = qIndex === -1 ? {} : Object.fromEntries(new URLSearchParams(raw.slice(qIndex + 1)));

  const parts = (path || 'dashboard').split('/');
  const page = parts[0] || 'dashboard';
  const param = parts[1] || null;
  if (page === 'clients' && param)
    return {
      view: 'clientDetail',
      selectedClient: param,
      selectedDevice: null,
      query,
    };
  if (page === 'devices' && param)
    return {
      view: 'deviceDetail',
      selectedDevice: param,
      selectedClient: null,
      query,
    };
  // `param` : second segment des autres vues (`#/websites/{id}`), que la vue lit elle-même.
  return {
    view: page,
    selectedClient: null,
    selectedDevice: null,
    param,
    query,
  };
}

export function viewToHash(view, selectedClient, selectedDevice, query) {
  // Les valeurs vides sont écartées : une URL ne doit porter que les filtres
  // réellement posés, sinon `#/alerts?severity=&category=` s'accumule et
  // devient illisible.
  const qs = new URLSearchParams(
    Object.entries(query || {}).filter(
      ([, v]) => v !== null && v !== undefined && v !== '' && v !== false
    )
  ).toString();
  const suffix = qs ? '?' + qs : '';

  if (view === 'clientDetail' && selectedClient) return '#/clients/' + selectedClient + suffix;
  if (view === 'deviceDetail' && selectedDevice) return '#/devices/' + selectedDevice + suffix;
  if (view === 'dashboard') return '#/' + suffix;
  return '#/' + view + suffix;
}
